module.exports = __webpack_public_path__ + "img/default_user.b8982e19.png";